import { render } from "./VideoTeaser.vue?vue&type=template&id=a74ee38e"
import script from "./VideoTeaser.vue?vue&type=script&lang=js"
export * from "./VideoTeaser.vue?vue&type=script&lang=js"

import "./VideoTeaser.vue?vue&type=style&index=0&id=a74ee38e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__